// extracted by mini-css-extract-plugin
export default {"container":"DraggedRows_container__ho1hZ","dragged":"DraggedRows_dragged__RCzlH"};